import React, { useState } from 'react'
import { 
    Box,
    Button,
    IconButton,
    Paper,
    Step,
    StepLabel, 
    Stepper, 
    TextField, 
    Typography 
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircleIcon from '@mui/icons-material/Circle';

import ListaDiagramas from './ListaDiagramas';
import { BlockPicker, TwitterPicker } from 'react-color';


const steps = ['Nombre', 'Agregar diagramas', 'Guardar'];

const ColeccionStep = (props) => {

    const {
        handleClose, 
        crearColeccion, 
        setNombreColeccion,
        nombreColeccion,
        diagramas,
        editarDiagrama,
        eliminarDiagrama,
        setColecciones,
        colecciones,
        diagramasColeccion,
        setColorColeccion,
        colorColeccion
    } = props;

    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const [mostrarColor, setMostrarColor] = useState('');
    const [colorActual, setColorActual] = useState(colorColeccion)

    const cambiarColor = (color)=>{
        setColorActual(color.hex);
        setColorColeccion(color.hex);
        /* console.log(color) */
    }

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
        // You probably want to guard against something like this,
        // it should never occur unless someone's actively trying to break something.
        throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                        labelProps.optional = (
                        <Typography variant="caption">Optional</Typography>
                        );
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            {activeStep === steps.length ? (
                <>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        All steps completed - you&apos;re finished
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Reset</Button>
                    </Box>
                </>
            ) : (
                <>
                   
                    <br/>
                    {activeStep === 0 && (
                        <Paper 
                            component="form"
                            style={{color: 'red'}}
                            sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                fullWidth: true
                            }}    
                        > 
                            
                            <IconButton
                                style={{
                                    color: colorActual
                                }}
                                onClick={()=>{setMostrarColor(!mostrarColor)}}
                            >
                                <CircleIcon
                                    sx={{p: '10px'}}
                                    
                                />
                            </IconButton>
                            <TextField 
                                sx={{ flex: 1 }}
                                label="Nombre colección" 
                                variant="outlined"
                                value={nombreColeccion} 
                                onChange={(e)=>{setNombreColeccion(e.target.value)}}
                            />
                            {
                            mostrarColor ? 
                            (
                                <div style={ {
                                    position: 'absolute',
                                    zIndex: '2',
                                    marginTop: '130px',
                                    marginLeft: '9px'
                                }}>
                                    <div 
                                        style={{
                                            position: 'fixed',
                                            top: '0px',
                                            right: '0px',
                                            bottom: '0px',
                                            left: '0px',
                                        }}
                                        onClick={()=>{setMostrarColor(!mostrarColor)}}
                                    />
                                    
                                    <TwitterPicker
                                        color={ colorActual } 
                                        onChange={ cambiarColor }
                                    />
                                </div> 
                            )
                            :
                            (
                                null
                            )
                        }
                        </Paper>
                    )} 
                    {activeStep === 1 && (
                        <ListaDiagramas
                            setColecciones={setColecciones}
                            colecciones={colecciones}
                            diagramas={diagramas}
                            diagramasColeccion={diagramasColeccion}
                            nombreColeccion={nombreColeccion}
                            colection={true}
                        />
                    )}
                    {activeStep === 2 && (
                        <Typography variant="h5" align='center'>
                            Presione 'GUARDAR' para crear colección.
                        </Typography>
                    )}  
                    
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <IconButton
                            color={"primary"}
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            <ArrowBackIosIcon/>
                        </IconButton>
                    <Box sx={{ flex: '1 1 auto' }} />

                    { activeStep === steps.length-1 ?
                        (<Button onClick={crearColeccion} >Guardar</Button>)
                        
                        :
                        (
                            <IconButton 
                                onClick={handleNext} 
                                color='primary'
                            >
                                <ArrowForwardIosIcon/>
                            </IconButton>
                        )
                    }
                    
                    </Box>
                </>
            )}
        </Box>
    )
}

export default ColeccionStep